var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaymentMethodBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8109 10.968C16.8109 13.7678 14.5415 16.0376 11.742 16.0376C8.94253 16.0376 6.6731 13.7678 6.6731 10.968C6.6731 8.16816 8.94253 5.89844 11.742 5.89844C14.5415 5.89844 16.8109 8.16816 16.8109 10.968ZM12.9598 9.0845C13.6649 9.32666 14.1807 9.68927 14.0795 10.3641C14.006 10.8582 13.7311 11.0972 13.3658 11.1809C13.8669 11.4408 14.0377 11.9341 13.879 12.5306C13.5777 13.3889 12.8615 13.4612 11.9088 13.2818L11.6775 14.2045L11.1191 14.0656L11.3472 13.1553C11.2024 13.1195 11.0545 13.0811 10.9021 13.0402L10.673 13.955L10.1152 13.8162L10.3462 12.8916L9.22139 12.6089L9.49885 11.9717C9.49885 11.9717 9.91058 12.0805 9.90486 12.0725C10.063 12.1115 10.1333 12.0088 10.161 11.9407L10.7878 9.43633C10.7948 9.3181 10.7538 9.16913 10.5276 9.11271C10.5361 9.10669 10.1219 9.01223 10.1219 9.01223L10.2705 8.41792L11.3968 8.6959L11.6259 7.78177L12.184 7.9206L11.9597 8.81666C12.1099 8.85058 12.2607 8.88513 12.4074 8.92158L12.6301 8.03122L13.1886 8.17005L12.9598 9.0845ZM11.6236 10.6093C12.004 10.7102 12.8317 10.9296 12.976 10.3542C13.1232 9.76542 12.319 9.5876 11.9252 9.50053C11.8806 9.49067 11.8413 9.48197 11.8092 9.47397L11.5311 10.5852C11.5576 10.5918 11.5887 10.6001 11.6236 10.6093L11.6236 10.6093ZM11.1926 12.3985C11.6482 12.5185 12.6447 12.781 12.8032 12.1469C12.9655 11.4985 11.9994 11.2826 11.528 11.1772L11.5279 11.1772C11.4753 11.1654 11.4288 11.155 11.3908 11.1456L11.084 12.3703C11.1152 12.3781 11.1517 12.3877 11.1926 12.3985Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodBitcoin);
export default __webpack_public_path__ + "static/media/icon_payment_method_bitcoin.e7df0052d63b8c73d84d07381870a2b8.svg";
export { ForwardRef as ReactComponent };